import { render } from "./Index.vue?vue&type=template&id=ef69cb7e"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=ef69cb7e&lang=scss"
script.render = render

export default script